import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const getSafeHeaders = () => {
  return {
    'access-control-allow-origin': '*',
    'Content-Type': 'application/json; charset=utf-8'
  };
};
// const headers = getSafeHeaders();
const shouldUseBackend = true;

i18n
  .use(LanguageDetector)
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    load: 'currentOnly',
    interpolation: {
      escapeValue: false
    },
    supportedLngs: ['en', 'zh', 'ja'],
    detection: {
      order: ['querystring', 'localStorage', 'cookie', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    backend: shouldUseBackend
      && {
        allowMultiLoading: false,
        loadPath: `${process.env.REACT_APP_BASE_URL}/localization/list`,
        requestOptions: {
          method: 'POST',
          headers: getSafeHeaders()
        },
        parseLoadPayload: (lngs) => {
          const lang = Array.isArray(lngs) ? lngs[0] : lngs;
          return lang;
        },
        parse: (data) => {
          try {
            const parsedData = JSON.parse(data);
            let raw = parsedData?.localizationData;
            if (typeof raw === 'string') {
              raw = JSON.parse(raw);
            }
            return raw || {};
          } catch (error) {
            console.error('Error parsing translation data:', error);
            return {};
          }
        }
      },
    resources: undefined
    // resources: {
    //   en: {
    //     translation: {
    //       pageNotFound: 'Page Not Found'
    //     }
    //   }
    // }
  });

export default i18n;
